import React from 'react';

export const PercentageIcon = ({
  percentage,
  color = '#7458dbf2',
}: {
  percentage: number;
  color?: string;
}) => {
  if (percentage === 100) {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17" cy="17" r="16" fill="#6db76fff" />
        <path
          d="M14.5 22.5l-4-4 1.4-1.4 2.6 2.6 7.6-7.6 1.4 1.4-9 9z"
          fill="#fff"
        />
      </svg>
    );
  }
  const radius = 16;
  const strokeWidth = 6;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset =
    circumference - (Math.min(percentage, 100) / 100) * circumference;

  return (
    <svg width="18" height="18" viewBox="0 0 36 36">
      <circle
        cx="18"
        cy="18"
        r={normalizedRadius}
        fill="none"
        stroke="#e0e0e0"
        strokeWidth={strokeWidth}
      />
      <circle
        cx="18"
        cy="18"
        r={normalizedRadius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        transform="rotate(-90 18 18)"
      />
    </svg>
  );
};
